import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

// External components
import Multiselect from "../multiselect";

@Component({ components: { Multiselect } })
export default class AddressMultiselect extends Vue {
  @Prop({ default: null }) selectedAddress;
  @Getter getUser;

  onSelectAddress($event) {
    this.$emit("on-select-address", $event);
  }
}
